/**
 * @fileoverview styled components 常用函数及变量, 不想写less的同学可以尝试使用
 * @author 杨文宇
 */

export const rem = (px: number) => {
  return px / 72 + 'rem';
};

export const vw = (px: number) => {
  return px / 7.2 + 'vw';
};

export const androidTheme: Theme = {
  background: '#19191e',
  inputBackground: 'rgba(255, 255, 255, 0.05)',
};

export const iosTheme: Theme = {
  background: '#000',
  inputBackground: 'rgba(255, 255, 255, 0.08)',
};

export interface Theme {
  background: string;
  inputBackground: string;
}
